import React from "react";
import BaseBtn from "./BaseBtn";
import styles from "./index.module.scss";
interface FooterBtnProps {
  btnText: string;
  onClick: () => void;
  topChild?: React.ReactNode;
  bottomChild?: React.ReactNode;
}
export default function FooterBtn({
  btnText,
  onClick,
  topChild,
  bottomChild,
}: FooterBtnProps) {
  return (
    <footer className={styles.footerContainer}>
      <div className={styles.footerVoid}></div>
      <div className={styles.footerContent}>
        {topChild && topChild}
        <BaseBtn text={btnText} className={styles.largeBtn} onClick={onClick} />
        {bottomChild && bottomChild}
      </div>
    </footer>
  );
}
